import { useState } from "react";
import { singletonHook } from "react-singleton-hook";
import { useProductApi } from "../custom-hooks/useProductApi";

export interface PcPrivacyAPI {
    getData: () => Promise<PcPrivacyUserData>
}

export interface PcPrivacyUserData {
    tokenLicence: string
    tokenStatus: string
}

export const usePcPrivacyUseData = singletonHook<PcPrivacyAPI | undefined>(undefined, function () {

    const api = useProductApi<PcPrivacyUserData>();
    const defaultResponse: PcPrivacyUserData = { tokenLicence: 'Token not round', tokenStatus: "" };
    const pcApi: PcPrivacyAPI = {
        getData: async () => {
            return api ? api.single('pcPrivacy/PcprivacyUserData')
                .catch(() => {
                    return defaultResponse;
                }) : defaultResponse;
        }
    };

    return pcApi;
});